var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"btn btn-primary",attrs:{"href":_vm.speaker.form_embed_url,"target":"_blank"}},[_vm._t("default",function(){return [_vm._v("Make booking enquiry")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }